import React from 'react';
import PropTypes from 'prop-types';
import { CTA, Image } from '../../..';

import ResultsTile from '../../../../templates/plp/results/tile';

import './index.css';

const ShopCard = ({ data, className }) => (
	<div className={`shopCard group/ptc h-full md:bg-white ${className || ''}`}>
		{data?.card?.[0] && (
			<div className='shopCard-top hidden items-center px-2 py-6 md:mb-6 md:grid md:grid-cols-2 md:grid-rows-[auto,1fr] xl:mb-3 xl:p-0'>
				{data.card[0]?.image?.[0] && (
					<Image
						data={data.card[0].image[0]}
						className={`shopCard-image relative z-1 col-start-1 row-start-1 motion-safe:transition-opacity md:h-[228px] xl:h-[204px] ${data.card[0].icon?.url ? '!hidden xl:!block xl:group-focus-within/ptc:opacity-0 xl:group-hover/ptc:opacity-0' : ''}`}
					/>
				)}

				{data.card[0]?.icon?.url && (
					<Image
						data={{ image: data.card[0].icon, contain: true }}
						className='shopCard-cob col-start-1 row-start-1 !block md:h-[228px] xl:h-[204px] xl:[&_img]:!mt-6 xl:[&_img]:!h-[calc(100%-48px)]'
					/>
				)}

				<div className='shopCard-content p-6'>
					{data.card[0]?.heading && (
						<div
							className='shopCard-heading text-xl font-bold'
							dangerouslySetInnerHTML={{ __html: data.card[0].heading }}
						/>
					)}
					{data.card[0]?.ctas?.[0] && (
						<CTA
							data={data.card[0].ctas[0]}
							className='shopCar-cta mt-5 tracking-wider'
							size='sm'
						/>
					)}
				</div>
			</div>
		)}

		<div className='shopCard-bottom md:p-2'>
			{data.subheading && <p className='shopCard-subheading mb-3 text-lg font-semibold md:text-base'>{data.subheading}</p>}

			{data.tiles?.[0] && (
				<div className='shopCard-tiles grid grid-cols-1 gap-y-2 md:grid-cols-2 md:gap-x-2 md:gap-y-0'>
					{data.tiles.map((tile, index) => (
						<ResultsTile
							key={index}
							tile={tile}
							pdpURL={tile.static_url}
							variant='horizontal'
							className={`shopCard-tile-${index} [&_img]:h-24 xl:[&_img]:h-[120px]`}
						/>
					))}
				</div>
			)}
		</div>
	</div>
);

ShopCard.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default ShopCard;
